import React from 'react'
import { Flex } from '@chakra-ui/react'; 
import robot from '../../assets/robot.gif'

const WelcomeChat = () => {
  return (
    <Flex
      height="100vh" 
      alignItems="center" 
      justifyContent="center" 
    >
      <img src={robot} alt="Robot" />
    </Flex>
  )
}

export default WelcomeChat
